module.exports = __webpack_public_path__ + "img/heart_2.b7975cba.png";